import {DateRangeType} from 'common/widgets/date-range-picker/models/types';
import {
  BooleanOperator,
  FilterOperator,
  ListOperator,
  NumberOperator,
  ObjectOperator,
  PropertyType,
  StringOperator,
} from 'common/widgets/property-filter-menu/models/types';

export interface OperatorDescription {
  symbol: string;
  label: string;
}

/**
 * Defines a symbol and description for each filter operator, on every property type
 * this list is sorted by usage metrics on p3 https://mixpanel.com/s/2ebosG
 */
export const PropertyTypeOperatorMap = new Map<PropertyType, {[key in FilterOperator]?: OperatorDescription}>([
  [
    PropertyType.Datetime,
    {
      [DateRangeType.RelativeAfter]: {symbol: `in the last`, label: ``},
      [DateRangeType.Between]: {symbol: `between`, label: ``},
      [DateRangeType.NotBetween]: {symbol: `not between`, label: ``},
      [DateRangeType.On]: {symbol: `on`, label: ``},
      [DateRangeType.NotOn]: {symbol: `not on`, label: ``},
      [DateRangeType.RelativeBefore]: {symbol: `before the last`, label: ``},

      [DateRangeType.NotRelativeAfter]: {symbol: `not in the last`, label: ``},
      [DateRangeType.Before]: {symbol: `before`, label: ``},
      [DateRangeType.Since]: {symbol: `since`, label: ``},
      // cohort specific operators (not yet supported in property filters)
      // [DateRangeType.RelativeFuture]: {symbol: `in the next`, description: ``},
    },
  ],
  [
    PropertyType.Object,
    {
      [ObjectOperator.Equals]: {symbol: `=`, label: `equals`},
      [ObjectOperator.Set]: {symbol: `{=}`, label: `is set`},
    },
  ],
  [
    PropertyType.List,
    {
      [ListOperator.Contains]: {symbol: `∋`, label: `contains`},
      [ListOperator.DoesNotContain]: {symbol: `∌`, label: `does not contain`},
    },
  ],
  [
    PropertyType.Number,
    {
      [NumberOperator.EqualTo]: {symbol: `=`, label: `equals`},
      [NumberOperator.NotEqualTo]: {symbol: `≠`, label: `not equal`},
      [NumberOperator.GreaterThan]: {symbol: `>`, label: `greater than`},
      [NumberOperator.AtLeast]: {symbol: `≥`, label: `greater than or equal`},
      [NumberOperator.Between]: {symbol: `∈`, label: `between`},
      [NumberOperator.NotBetween]: {symbol: `∉`, label: `not between`},
      [NumberOperator.LessThan]: {symbol: `<`, label: `less than`},
      [NumberOperator.AtMost]: {symbol: `≤`, label: `less than or equal`},
    },
  ],
  [
    PropertyType.Boolean,
    {
      [BooleanOperator.True]: {symbol: `is True`, label: null},
      [BooleanOperator.False]: {symbol: `is False`, label: null},
    },
  ],
  [
    PropertyType.String,
    {
      [StringOperator.Equals]: {symbol: `=`, label: `equals`},
      [StringOperator.DoesNotEqual]: {symbol: `≠`, label: `does not equal`},
      [StringOperator.Contains]: {symbol: `∋`, label: `contains`},
      [StringOperator.DoesNotContain]: {symbol: `∌`, label: `does not contain`},
      [StringOperator.Set]: {symbol: `is set`, label: ``},
      [StringOperator.NotSet]: {symbol: `is not set`, label: ``},
    },
  ],
]);
